import * as yup from 'yup';
import { requiredImageFromCMSSchema } from '../schemas';

export const schema = yup
  .object({
    fresh: yup.object({
      chicken: requiredImageFromCMSSchema,
      beef: requiredImageFromCMSSchema,
      turkey: requiredImageFromCMSSchema,
      pork: requiredImageFromCMSSchema,
      lamb: requiredImageFromCMSSchema,
    }),
    baked: yup.object({
      beef: requiredImageFromCMSSchema,
      chicken: requiredImageFromCMSSchema,
    }),
  })
  .transform(value => ({
    fresh: value.fresh,
    baked: value.baked,
  }));
